import React from "react";

function EventHero({ language = "en" }) {
  return (
    <section className="hero contact-hero">
      {/* الخلفية */}
      <div
        className="hero-slides"
        style={{
          backgroundImage: "url(/img/jr5.png)",
        }}
      />

      {/* العنوان */}
      <h1>{language === "ar" ? "الخدمات المتكاملة من إدارة المعارض والمؤتمرات والتسويق والاستشارات الإعلامية" : "Integrated Event Management and Strategic Marketing and Media Solutions Consulting"}</h1>

      {/* العبارات الثابتة */}
      <div className="hero-texts">
        <div className="hero-text active">
          <p>
            {/* {language === "ar"
              ? "خدمات استشارية إدارية احترافية"
              : "Professional Management Consulting Services"} */}
          </p>
          <p>
            {language === "ar"
              ? " نخطط وندير وننفذ معارض ومؤتمرات وحملات تسويقية متكاملة بمعايير احترافية عالية "
              : "We plan, manage, and deliver world-class exhibitions, conferences, and integrated marketing campaigns."}
          </p>
        </div>
      </div>

      {/* الزر */}
      <a href="#contact" className="btn">
        {language === "ar" ? " أرسل طلباً" : "SEND A REQUEST"}
      </a>

      {/* Dot واحدة (اختياري) */}
      <div className="slider-dots">
        <div className="dot active" />
      </div>
    </section>
  );
}

export default EventHero;
